module.exports = __webpack_public_path__ + "static/fipi_work-3f1d9b5808b788255a562dfd799be353.jpeg";